const KEY = "evpos-public-branding"

const defaultStorage = () => {
	try {
		return globalThis.sessionStorage ?? null
	} catch {
		return null
	}
}

/**
 * Branding kept from the last public page of this tab, so the next page loads with the operator colors.
 *
 * @param {Storage|null} [storage] - storage to read, the tab session storage by default
 *
 * @returns {Object|null} saved branding, null when there is none or it cannot be read
 * */
export const readStoredBranding = (storage = defaultStorage()) => {
	try {
		const parsed = JSON.parse(storage?.getItem(KEY) ?? "null")
		return parsed && typeof parsed === "object" ? parsed : null
	} catch {
		return null
	}
}

/**
 * Keeps the branding of the page just loaded for the next public page of this tab.
 *
 * @param {Object|null} branding - branding of the API response
 * @param {Storage|null} [storage] - storage to write, the tab session storage by default
 * */
export const storeBranding = (branding, storage = defaultStorage()) => {
	try {
		if (branding) storage?.setItem(KEY, JSON.stringify(branding))
	} catch {
		// Storage can be blocked or full, the pages work without it.
	}
}
